<template>
	<div>
	</div>
</template>

<script scoped>
import { baseApiUrl, showError, showSuccess } from '@/config/global'
import axios from 'axios'

	
	export default{
		name: 'NovaSenha',
		components:{},
		computed:{
		},
		data(){
			return{
				dadosConfirmacao: {}
			}
		},

		methods: {
			confirmaToken(){
                const url = `${baseApiUrl}/utils/validaTokenAtendimento.php`

                axios.post(url, {tk : this.dadosConfirmacao.token})
				.then(res => {
					if(res.data.codigo == '01'){
                        //showSuccess()
                        this.dadosConfirmacao.idAtendimento = res.data.id
                        this.dadosConfirmacao.email = res.data.email
                        this.dadosConfirmacao.tkValido = true
					}else{
						showError(res.data.mensagem)
						this.$router.push({path: 'auth'})
						return
					}
                })
            },
            
            registrarConfirmacao(){
                const url = `${baseApiUrl}/Atendimentos/Fichas/insertConfirmacao.php`
                axios.post(url, this.dadosConfirmacao)
                .then(res => {
                    if(res.data.codigo == '01'){
                        this.enviarEmailIniciados(this.dadosConfirmacao.idAtendimento, this.dadosConfirmacao.confirmacao)
                        showSuccess(res.data.mensagem)
                    }else{
                        showError(res.data.mensagem)
                    }
                })
            },

            async buscaIp(){
                await axios.get("https://api.ipify.org?format=jsonnp&callback=?")
                .then(res => {
                    this.dadosConfirmacao.ip = res.data
                    //gerar arquivo log caso nao consiga recuperar o ip
                })
            },
            
            enviarEmailIniciados(id, confirmacao){
            const urlEmail = `${baseApiUrl}/emails/iniciadosAtendimento.php`
            
            axios.post(urlEmail, {id: id, confirmacao: confirmacao})
            
        },
			
		},
	
		async created(){
            this.dadosConfirmacao.token = this.$route.params.token
            this.dadosConfirmacao.confirmacao = this.$route.params.confirmado
            this.dadosConfirmacao.idAtendimento = 0
            this.dadosConfirmacao.timestamp = new Date().getTime()
            await this.confirmaToken()
            await this.buscaIp()
            await this.registrarConfirmacao()
		}
	}


</script>

<style scoped>
	
</style>